import { formatMoney } from "@hex-insights/core";
import { defaultCurrency } from "../../../Utilities";

export function money(value: number | null, currency: string | null = defaultCurrency) {
	// TODO handling for school's setting currency
	try {
		return formatMoney(value, { areCents: true, formatOptions: { currency: currency ?? defaultCurrency } });
	} catch {
		return formatMoney(value, { areCents: true, formatOptions: { currency: defaultCurrency } });
	}
}
